export default __webpack_public_path__ + "static/media/mern.713b0d3b.png";